import { LinkBanner, Page } from '@/components';
import FarmsIcon from '@/components/icons/Farms';

import { useSearchParams } from '@/hooks';
import { Box, Flex, Heading } from '@blockanalitica/ui';
import FarmKpiTab from './FarmKpiTab';
import HistoricGraphs from './HistoricGraphs';

export default function FarmsPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');

  return (
    <Page
      title={
        <Flex gap="2xs" alignItems="center">
          <FarmsIcon size="5" />
          <Heading size="1">Rewards</Heading>
        </Flex>
      }>
      <LinkBanner
        text="Start Receiving Rewards"
        linkTo="https://app.sky.money/?widget=rewards&network=ethereum">
        <Box paddingTop="xs" paddingBottom="m" maxWidth="85%">
          <Heading size="2">About Sky Token Rewards</Heading>
          <br />
          The Sky Token Rewards module accepts deposits of USDS into a
          non-custodial smart contract. Accounts that supply USDS become
          eligible to receive Sky Token Rewards over time, as determined by
          governance-approved parameters (rates and schedules are variable and
          not guaranteed). Assets and rewards are held by the contract on-chain;
          no intermediary takes custody, and claims/redemptions follow the
          protocol’s rules and occur directly on-chain.
        </Box>
      </LinkBanner>
      <FarmKpiTab daysAgo={daysAgo} />
      <HistoricGraphs />
    </Page>
  );
}
